import { Component, OnInit,HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';

import { AlertService } from '../../services/auths/alert.service';
import {AuthenticationService} from '../../services/auths/authentication.service';
import {ClientService} from '../../services/client.service';
import { User } from 'src/app/models/user';
import {Client} from 'src/app/models/client';

@Component({
  selector: 'app-initpassword',
  templateUrl: './initpassword.component.html',
  styleUrls: ['./initpassword.component.css']
})
export class InitpasswordComponent implements OnInit {
  InitpassForm: FormGroup; //import { FormBuilder, FormGroup, Validators } from '@angular/forms';
  loading = false;
  submitted = false;
  returnUrl: string;
  public user:User;
  public client:Client;
  message = 'Utilisateur inexistant.';
  etatconnexion:boolean=false;
  classes = 'example-items-rows';

  positions = NbGlobalPhysicalPosition;
  constructor(  
          private formBuilder: FormBuilder,
          private route: ActivatedRoute,
          private router: Router,
          private authenticationService: AuthenticationService,
          private alertService: AlertService,
          private clientRep: ClientService,
          private toastrService: NbToastrService) { }

  ngOnInit(): void {
    this.InitpassForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }
    // convenience getter for easy access to form fields
    get f() { return this.InitpassForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.InitpassForm.invalid) {
        return;
    }
    this.loading = true;
    this.authenticationService.sendinfos(this.f.email.value)
        .pipe(first())
        .subscribe(
            (response) => {
                if (response.success) {
                    this.message = response.message || 'Envoi effectué avec succès. Veuillez consulter votre boîte mail pour la suite des instructions.';
                    this.showToast(this.positions.TOP_RIGHT, this.message, 'success');
                } else {
                    this.message = response.message || "Échec de l'envoi. Veuillez vérifier votre connexion, puis réessayer.";
                    this.showToast(this.positions.TOP_RIGHT, this.message, 'danger');
                }
                this.loading = false;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
  }
  
    showToast(position, msg, status) {
  
      this.toastrService.show(status || 'Success', msg, { position, status });
    }
}
